import { IExportTemplate } from './index';

export class IExportDataTemplate {
  exportTemplateId: number;
  exportTemplateName: string;
  content: IExportTemplate;
  changeUser: string;
  changeDateTime: Date;
  createUser: string;
  createDateTime: Date;
}
